module.exports = __webpack_public_path__ + "img/delete.3a0821dc.svg";